import LuggageColor from './LuggageColour.svg';
import LuggageDark from './LuggageDark.svg';
import LuggageLight from './LuggageLight.svg';
export const luggage = { color: LuggageColor, dark: LuggageDark, light: LuggageLight };
//# sourceMappingURL=index.js.map